export const getImagePreview = (file: File): string | Promise<string> => {
  if (!file?.type?.match('image.*') || !FileReader) return null

  return new Promise((resolve, reject) => {
    try {
      const imageFile = new File([file], file.name, {
        type: file.type,
        lastModified: new Date().getTime(),
      })

      resolve(URL.createObjectURL(imageFile))
    } catch (err) {
      reject(err)
    }
  })
}
